import { render } from "./GridTabItems.vue?vue&type=template&id=851ad4b6"
import script from "./GridTabItems.vue?vue&type=script&lang=js"
export * from "./GridTabItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__